import React from 'react';
import GroupForm from './GroupForm';

const ViewGroup = () => {
  return <GroupForm mode="view" />;
};

export default ViewGroup;
